import { ElMessage, ElLoading } from 'element-plus';
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/loading/style/css'

import { mixins } from "@/plugins/mixins";
import bus from "@/plugins/bus";
export default {
  name: "deptAdd",
  mixins: [mixins],
  data() {
    return {
      edit: false,
      formModel: {
        deptId: null,
        deptCode: null,
        deptName: null,
        parentId: null
      },
      formRules: {
        deptCode: [{
          required: true,
          message: '请输入部门编码',
          trigger: 'blur'
        }, {
          max: 16,
          message: '部门编码长度不能超过16',
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z_0-9]+$/,
          message: '部门编码必须为字母、数字或_',
          trigger: 'blur'
        }],
        deptName: [{
          required: true,
          message: '请输入部门名称',
          trigger: 'blur'
        }, {
          max: 32,
          message: '部门名称长度不能超过32',
          trigger: 'blur'
        }]
      },
      deptList: [],
      deptProps: {
        checkStrictly: true,
        emitPath: false,
        value: 'deptId',
        label: 'deptName'
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          const callBack = res => {
            if (res.code === 200) {
              ElMessage({
                message: res.message,
                type: 'success'
              });
              this.$router.back();
              if (this.$route.meta && this.$route.meta.parent) {
                bus.emit(this.$route.meta.parent, true);
              }
            } else {
              ElMessage.error(res.message);
            }
          };
          if (this.edit) {
            this.$api.uac.dept.update(this.formModel).then(callBack);
          } else {
            this.$api.uac.dept.create(this.formModel).then(callBack);
          }
        }
      });
    }
  },
  beforeMount() {
    if (this.$route.query.deptId) {
      this.edit = true;
      const loading = ElLoading.service();
      this.$api.uac.dept.detail(this.$route.query.deptId).then(res => {
        if (res.code === 200) {
          this.formModel = Object.assign(this.formModel, res.data);
        } else if (res.code === 101402) {
          this.$router.replace({
            name: '404'
          });
        } else {
          ElMessage.error(res.message);
          this.$router.back();
        }
      }).finally(() => {
        loading.close();
      });
    }
    this.$api.uac.dept.list().then(res => {
      if (res.code === 200) {
        this.deptList = res.data;
      }
    });
  }
};